import React, {useState} from 'react';
import {useAsyncRetry} from 'react-use';
import {useApiClient} from "../../base/hooks/useApiClient";
import {Page} from '../../layout/Page';
import {Session} from "../../../types";
import {CreateSessionButton} from "./SessionRow/CreateSessionButton";
import {SessionRow} from "./SessionRow/SessionRow";
import {Pagination} from "./Pagination";

export function SessionTablePage() {
    const apiClient = useApiClient();
    const [currentPage, setCurrentPage] = useState(1);
    const [sessionsPerPage, setSessionsPerPage] = useState(5);

    const { value: sessions = [], retry: reloadSessions } = useAsyncRetry(async () => {
        const response = await apiClient.get('sessions');

        if (!response.ok) {
            throw new Error('Cannot fetch list of sessions');
        }

        const data = await response.json() as { sessions: Session[] };

        return data.sessions;
    }, []);

    const indexOfLastSession = currentPage * sessionsPerPage;
    const indexOfFirstSession = indexOfLastSession - sessionsPerPage;
    const currentSessions = sessions.slice(indexOfFirstSession, indexOfLastSession);

    return (
        <Page>
            <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">Translation Sessions</h1>
                    <CreateSessionButton />
                </div>

                <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                    <div className="grid divide-y divide-gray-200">
                        {currentSessions.map((session) => (
                            <SessionRow key={session.uuid} session={session} onDelete={reloadSessions} />
                        ))}
                    </div>

                    <Pagination totalItems={sessions.length} onPageChange={setCurrentPage} onPerPageChange={setSessionsPerPage} />
                </div>
            </div>
        </Page>
    );
}
